import Container from '@material-ui/core/Container';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
// import TextField from '@material-ui/core/TextField';
import React from 'react';
import { AfterPageProps, wrapLayout } from '../../@sprinx/react-after-razzle';
import InfoLayout from '../../layouts/InfoLayout/InfoLayout';

export type CareerPageProps = AfterPageProps;
export type CareerPageClassNameKey = 'root';

const useStyles = makeStyles((theme: Theme) =>
  createStyles<CareerPageClassNameKey, {}>({
    root: {
      paddingTop: '150px',
      paddingBottom: '150px',
      [theme.breakpoints.down('sm')]: {
        paddingTop: theme.spacing(1),
      },
    },
  }),
);

const CareerPage: React.FC<CareerPageProps> = () => {
  const classes = useStyles();

  return (
    <>
      <Container>
        <div className={classes.root}>
          <h1>Kariéra</h1>

          <h2>Pracovní nabídky a volné pozice</h2>
        </div>
      </Container>
    </>
  );
};

CareerPage.displayName = 'CareerPage';

export default wrapLayout(CareerPage, InfoLayout);
